import { UserRole } from './permittedRoles';

export const roleLabels = {
    [UserRole.USER]: 'User',
    [UserRole.ADMIN]: 'Administrator',
    [UserRole.SYSTEM_ADMIN]: 'System-Administrator'
};
